<template>
    <div>
      <section class="reservation-intro">
        <h1>Réserver le petit gîte — Gîte d'en Lébé</h1>
        <p>
          Le petit gîte du Gîte d'en Lébé à Touget dans le Gers offre un hébergement confortable et autonome,
          parfait pour un séjour à deux dans un cadre calme au cœur d'une ferme biologique.
        </p>
        <p>
          Consultez les disponibilités ci-dessous et réservez directement en ligne.
          Découvrez aussi notre
          <router-link to="/nos-hebergements/le-gite">grand gîte pouvant accueillir jusqu'à 15 personnes</router-link>.
        </p>
        <p>
          Retrouvez nos
          <router-link to="/tarifs-et-reservation">tarifs et informations de réservation</router-link>
          ou <router-link to="/contact">contactez-nous</router-link> pour toute question.
        </p>
      </section>
      <div class="gite">
        <div class="gdf-WidgetBooking" data-source="owner" data-reference="H32G029763"></div>
      </div>
    </div>
</template>

<script>
export default {
    name: "reservationsPetitGite",
    data() {
        return {
            showReservation: true,
        };
    },

    mounted() {
        const script3 = document.createElement('script');
        script3.src = "https://widget.cloudspire.io/booking/sdk.js";
        script3.async = true;
        document.head.appendChild(script3);
    },

    beforeDestroy() {
        const script3 = document.querySelector('script[src="https://widget.cloudspire.io/booking/sdk.js"]');
        if (script3) {
            script3.remove();
        }
    },
};
</script>

<style scoped>
.reservation-intro {
  max-width: 900px;
  margin: 3rem auto 1rem;
  padding: 0 2rem;
  line-height: 1.6;
}

.reservation-intro h1 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.gite {
  margin: 5rem 11rem;
}

@media screen and (max-width: 450px) {
  .gite {
    margin: 0;
  }
}
</style>
